export const FOOTER_LINK_URL = {
  LOGO: "https://woowacourse.github.io/",
  GITHUB: "https://github.com/woowacourse/",
  YOUTUBE: "https://www.youtube.com/channel/UC-mOekGSesms0agFntnQang/featured?view_as=subscribe",
  INSTAGRAM: "https://instagram.com/wooteco?igshid=YmMyMTA2M2Y",
} as const;

export const INQUIRE_LINK_URL = "https://pf.kakao.com/_budWj";
